module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-l-dg.b262b7e8.svg";